var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlumbingServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9851 45.0984H28.2551C28.2551 41.5784 31.1151 38.7184 34.6351 38.7184H74.2151V28.4484H34.6351C25.4551 28.4484 17.9951 35.9184 17.9951 45.0884L17.9851 45.0984Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0251 18.7084C40.8351 18.5984 41.9751 17.8984 42.9151 17.6684C43.9451 17.4184 45.1151 17.2884 46.1751 17.3084C46.5851 17.3884 46.7051 17.9784 47.0351 18.3384C47.3751 18.7084 47.7851 18.9284 48.1451 19.2784V23.7584C46.2951 23.6084 44.1151 23.8084 44.0551 26.1184H56.8451C56.7851 23.8184 54.6051 23.6084 52.7551 23.7584V19.2784C53.1051 18.9284 53.5151 18.7084 53.8651 18.3384C54.1951 17.9784 54.3151 17.3884 54.7251 17.3084C55.7851 17.2884 56.9451 17.4184 57.9851 17.6684C58.9251 17.8984 60.0651 18.5984 60.8751 18.7084C65.9451 19.4184 65.6551 11.9584 60.8951 12.7884C60.2551 12.8984 59.4451 13.4384 58.7651 13.6484C57.4551 14.0584 54.5151 14.1284 54.5151 14.1284C52.6851 11.0484 48.2151 11.0484 46.3851 14.1284C46.3851 14.1284 43.4451 14.0584 42.1351 13.6484C41.4551 13.4384 40.6451 12.8984 40.0051 12.7884C35.2551 11.9684 34.9551 19.4184 40.0251 18.7084Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9151 27.1984V39.8284C75.9151 41.4784 77.2551 42.8184 78.9051 42.8184H81.0251V24.2184H78.9051C77.2551 24.2184 75.9151 25.5584 75.9151 27.2084V27.1984Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9251 46.8184H15.3051C14.4822 46.8184 13.8151 47.4854 13.8151 48.3084V50.4384C13.8151 51.2613 14.4822 51.9284 15.3051 51.9284H30.9251C31.748 51.9284 32.4151 51.2613 32.4151 50.4384V48.3084C32.4151 47.4854 31.748 46.8184 30.9251 46.8184Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9451 58.4384C20.2451 60.5284 17.3151 64.4784 17.3151 66.7584C17.3151 69.9684 19.9151 72.5684 23.1251 72.5684C26.3351 72.5684 28.9351 69.9684 28.9351 66.7584C28.9351 64.4784 26.0051 60.5284 24.3051 58.4384C23.6951 57.6884 22.5551 57.6884 21.9551 58.4384H21.9451Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 0.248352C23.1351 0.248352 0.745117 22.6384 0.745117 50.2484C0.745117 77.8584 23.1351 100.248 50.7451 100.248C78.3551 100.248 100.745 77.8584 100.745 50.2484C100.745 22.6384 78.3551 0.248352 50.7451 0.248352ZM66.8951 91.1684V71.8083C72.3451 69.5083 75.8651 64.1884 75.8651 58.2684C75.8651 54.2684 74.2851 50.5284 71.4151 47.7384C70.7951 47.1384 69.8951 47.0184 69.1251 47.4684C68.5151 47.8184 68.1751 48.4984 68.1751 49.2084V59.7784L61.1651 63.8084L54.1751 59.7684V49.2684C54.1751 48.5084 53.6251 47.5884 52.9051 47.3284C52.2151 47.0784 51.4651 47.2284 50.9351 47.7484C48.0651 50.5384 46.4851 54.2784 46.4851 58.2784C46.4851 64.1984 50.0051 69.5084 55.4551 71.8284V93.9984C53.9051 94.1684 52.3351 94.2584 50.7451 94.2584C26.4851 94.2584 6.74512 74.5184 6.74512 50.2584C6.74512 25.9984 26.4851 6.24835 50.7451 6.24835C75.0051 6.24835 94.7451 25.9884 94.7451 50.2484C94.7451 68.8084 83.1851 84.7084 66.8951 91.1684Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1721",
    x: -0.0000186563,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1721",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1721"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1721",
    result: "effect3_innerShadow_4857_1721"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingServicesIcon);
export default __webpack_public_path__ + "static/media/PlumbingServicesIcon.b53e17210e2e688bcf8d4e7b99b0d024.svg";
export { ForwardRef as ReactComponent };